module.exports = __webpack_public_path__ + "static/media/3DPPA6.3adea889.jpg";